import styled from 'styled-components';
import { mediaMin } from '@spa/shared/theme';

export const Wrapper = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
  width: 100%;
  height: 28px;
  background-color: rgba(34, 66, 81, 0.6);
  color: ${props => props.theme.typography.invertedColor};
  font-family: IntervalNextReg, sans-serif;
  font-weight: 100;
  line-height: normal;
  font-size: ${props => props.theme.rem(14)};
  border-radius: 0 0 12px 12px;

  ${props =>
    props.isFeatured &&
    `
    background-color: ${props.theme.backgrounds.uniBlueFaded};
  `}

  svg {
    width: 180px;

    ${mediaMin.smallBreakpoint`
      width: 150px;
    `}

    ${props =>
      props.isFeatured &&
      `
      width: 15px;
      margin-right: ${props.theme.space(1)};
    `}
  }
`;
